import { stateAbbreviation, isTerritory } from "../../utilities/charts/state_abbreviation_map";
import SimpleUsStateMapChartControllerBase from "./simple_us_state_map_chart_controller_base";

const NI_KEY = "N/I";
const NI_COLOR = "#d2d6dc";

// Categorical state map for a payer profile field. Chart data (from
// PayerProfile::CategoricalBreakdown#chart_data):
//   { options: [{ key, label, color }], states: { "IN": "Yes", ... } }
export default class extends SimpleUsStateMapChartControllerBase {
  categoryForState(abbreviation) {
    return this.params.states[abbreviation] || NI_KEY;
  }

  optionForState(abbreviation) {
    const category = this.categoryForState(abbreviation);

    return this.params.options.find(option => option.key === category);
  }

  valueForState(abbreviation) {
    return this.params.options.findIndex(
      option => option.key === this.categoryForState(abbreviation),
    );
  }

  colorForState(abbreviation) {
    return this.optionForState(abbreviation)?.color || NI_COLOR;
  }

  legendLabels(chart) {
    const presentCategories = new Set(
      chart.data.datasets[0].data
        .filter(datum => !isTerritory(datum.feature))
        .map(datum => this.categoryForState(stateAbbreviation(datum.feature))),
    );

    return this.params.options
      .filter(option => presentCategories.has(option.key))
      .map(option => ({
        text: option.label,
        fillStyle: option.color,
        pointStyle: "rect",
        fontColor: chart.legend.options.labels.color,
      }));
  }

  tooltipLabel(item) {
    return this.categoryForState(stateAbbreviation(item.raw.feature));
  }
}
